"use strict";
exports.__esModule = true;
exports.TeamMemberPositionsTranslationsMap = void 0;
var utilities_1 = require("../utilities/utilities");
exports.TeamMemberPositionsTranslationsMap = {
    goalkeeper: utilities_1.__('Brankár'),
    defender: utilities_1.__('Obranca'),
    midfielder: utilities_1.__('Stredopoliar'),
    forward: utilities_1.__('Útočník'),
    coach: utilities_1.__('Tréner'),
    assist_coach_a: utilities_1.__('Asistent trénera'),
    assist_coach_b: utilities_1.__('Asistent trénera'),
    coach_goalkeepers: utilities_1.__('Tréner brankárov'),
    doctor: utilities_1.__('Lekár'),
    masseur: utilities_1.__('Masér'),
    manager: utilities_1.__('Vedúci družstva'),
    club_representative: utilities_1.__('Člen realizačného tímu'),
    physiotherapist: utilities_1.__('Fyzioterapeut'),
    custodian: utilities_1.__('Kustód'),
    videoanalyst: utilities_1.__('Videoanalytik'),
    mental_coach: utilities_1.__('Mentálny tréner'),
    conditioning_coach: utilities_1.__('Kondičný tréner')
};
